import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {AdminResponse} from './types/admin-response';

@Injectable({
  providedIn: 'root'
})
export class AdminService {
  private readonly BASE_URL = '/sag/admin/';

  constructor(private http: HttpClient) {
  }

  pobierzParametr(klucze: string[]): Observable<AdminResponse> {
    return this.http.post<AdminResponse>(this.BASE_URL + 'parametry', klucze);
  }

}
